import { Column, Table, VisibilityState, flexRender,
    getCoreRowModel,
    useReactTable,} from '@tanstack/react-table';
import beaconMasterResultType from "../model/BeaconMasterResultType";
import { HTMLProps, useEffect, useState, useMemo } from 'react';
import { Checkbox } from 'semantic-ui-react';
import React from 'react';
import { Breadcrumb, Button, Col, Form, Row} from 'react-bootstrap';
import axios, { spread } from 'axios';
import ExcelJS from 'exceljs'; 
import Loading from './Loading';

type PropsType = {
  result: beaconMasterResultType[],
  bundle_ids: string[]
}


type uniqueUserType = {
  name: string,
  beacon_id: string,
  log_count: number,
  unique_count: number
}

type uniqueDeviceType = {
  device: number,
  unique_device: number,
  bleOn_device: number,
  bleOn_unique_device: number,
  bleOff_device: number,
  bleOff_unique_device: number,
  locOn_device: number,
  locOn_unique_device: number,
  locOff_device: number,
  locOff_unique_device: number

}

const BeaconMasterResult = (props:PropsType) => {
  const [detected_gt, setDetcted_gt] = useState<string>("");
  const [detected_lt, setDetcted_lt] = useState<string>("");
  const [spreadMonth, setSpreadMonth] = useState<string>("");
  const [spreadClientOptions, setSpreadClientOptions] = useState<string[]>([]);
  const [selectSpreadClient, setSelectSpreadClient] = useState<string>("")
  const [bundle_id_ios, setBundle_id_ios] = useState<string>("");
  const [bundle_id_and, setBundle_id_and] = useState<string>("");
  const [bundle_id_gate, setBundle_id_gate] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filterText, setFilterText] = useState<string>('');

  const data: beaconMasterResultType[] = props.result;
  const filteredData: beaconMasterResultType[] = useMemo(() => {
    if (!filterText) return data;
    const tokens = filterText
      .split(',')
      .map(t => t.trim().toLowerCase())
      .filter(Boolean);
    if (tokens.length === 0) return data;
    return data.filter(row => {
      for (const [, v] of Object.entries(row as any)) {
        if (v === null || v === undefined) continue;
        const t = typeof v;
        if (t === 'string' || t === 'number' || t === 'boolean') {
          const s = String(v).toLowerCase();
          if (tokens.some(token => s.includes(token))) {
            return false; // いずれかのトークンに部分一致したら除外
          }
        }
      }
      return true;
    });
  }, [data, filterText]);
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
  var apiUrl:string = "https://aggregate-log-api.bcw-mt.com:5001/api/getLogData/";
  var apiUniqueDeviceUrl = "https://aggregate-log-api.bcw-mt.com:5001/api/getUniqueDevice/"
  var apiUniqueDevLocOnUrl = "https://aggregate-log-api.bcw-mt.com:5001/api/getUniqueDeviceLocOn/"
  var apiUniqueDevLocOffUrl = "https://aggregate-log-api.bcw-mt.com:5001/api/getUniqueDeviceLocOff/"
  var apiUniqueDevBleOnUrl = "https://aggregate-log-api.bcw-mt.com:5001/api/getUniqueDeviceBleOn/"
  var apiUniqueDevBleOffUrl = "https://aggregate-log-api.bcw-mt.com:5001/api/getUniqueDeviceBleOff/"
  var beaconIdArray : string[] = []
  var bundleIdArray : string[] = []
  var uniqueCountArray : uniqueUserType[] = []
  var uniqueDevice : uniqueDeviceType = {
    device: 0,
    unique_device: 0,
    bleOn_device: 0,
    bleOn_unique_device: 0,
    bleOff_device: 0,
    bleOff_unique_device: 0,
    locOn_device: 0,
    locOn_unique_device: 0,
    locOff_device: 0,
    locOff_unique_device: 0
  }
  const columns = [
    {
      id: 'select',
      header: ({ table }) => (
        <IndeterminateCheckbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
      ),
      cell: ({ row }) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      ),
    },
    { header: "no", accessorKey: "no" },
    { header: "id", accessorKey: "id" },
    { header: "name", accessorKey: "name" },
    { header: "local_name", accessorKey: "local_name" },
    { header: "uuid", accessorKey: "uuid" },
    { header: "major", accessorKey: "major" },
    { header: "minor", accessorKey: "minor" },
    { header: "action", accessorKey: "action" },
    { header: "tx_power", accessorKey: "tx_power" },
    { header: "battery", accessorKey: "battery" },
    { header: "module_id", accessorKey: "module_id" },
    { header: "manufacturer", accessorKey: "manufacturer" },
    { header: "model", accessorKey: "model" },
    { header: "note", accessorKey: "note" },
    { header: "x", accessorKey: "x" },
    { header: "y", accessorKey: "y" },
    { header: "h", accessorKey: "h" },
    { header: "enabled", accessorKey: "enabled" },
    { header: "created", accessorKey: "created" },
    { header: "updated", accessorKey: "updated" }
    
  ];
    
  const table = useReactTable({
    columns,
    data: filteredData,
    getRowId: (row) => String((row as any).id),
    state: {
      columnVisibility: columnVisibility,
    },
    getCoreRowModel: getCoreRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
  })

  const getUniqueData = async (e: any) => {

    var gte = new Date(detected_gt).getTime() / 1000.0;
    var lte = new Date(detected_lt).getTime() / 1000.0;
    console.log(gte);
    console.log(lte);

    if (isNaN(gte)) {
      alert("Detect_gtが入力されていません");
      return
    } else if (isNaN(lte)) {
      alert("Detect_ltが入力されていません");
      return
    }

    if (bundle_id_ios == "" && bundle_id_and == "" && bundle_id_gate == "") {
      alert("BundleIDが入力されていません");
      return
    } else {
      if (bundle_id_ios != "") {
        bundleIdArray.push(bundle_id_ios)
      }
      if (bundle_id_and != "") {
        bundleIdArray.push(bundle_id_and)
      }
      if (bundle_id_gate != "") {
        bundleIdArray.push(bundle_id_gate)
      }
    }

    
    try {
      await getUniqueDevice(e, gte, lte)
      await getUniqueDeviceLocOn(e, gte, lte)
      await getUniqueDeviceLocOff(e, gte, lte)
      await getUniqueDeviceBleOn(e, gte, lte)
      await getUniqueDeviceBleOff(e, gte, lte)
      console.log(uniqueDevice)
      createUniqueDeviceCsv()
      setIsLoading(false);
    } catch {
      alert("エラーが発生しました。")
      setIsLoading(false);
    }
  }

  const getBeaconIds = async (e: any, type: string) => {
    
    //APIのパラメータ作成
    beaconIdArray.splice(0)
    table.getSelectedRowModel().rows.forEach ((el) => {
      beaconIdArray.push(el.original.id);
      if (type == "Unique") {
        var uniqueCount: uniqueUserType = {
          name: el.original.name,
          beacon_id: el.original.id,
          log_count: 0,
          unique_count: 0
        };
        
        uniqueCountArray.push(uniqueCount);
      }
    });

    console.log(uniqueCountArray)
    if (beaconIdArray.length <= 0) {
      alert("ビーコンが選択されていません。");
      return
    }

    var gte = new Date(detected_gt).getTime() / 1000.0;
    var lte = new Date(detected_lt).getTime() / 1000.0;
    console.log(gte);
    console.log(lte);

    if (isNaN(gte)) {
      alert("Detect_gtが入力されていません");
      return
    } else if (isNaN(lte)) {
      alert("Detect_ltが入力されていません");
      return
    }

    if (bundle_id_ios == "" && bundle_id_and == "" && bundle_id_gate == "") {
      alert("BundleIDが入力されていません");
      return
    } else {
      if (bundle_id_ios != "") {
        bundleIdArray.push(bundle_id_ios)
      }
      if (bundle_id_and != "") {
        bundleIdArray.push(bundle_id_and)
      }
      if (bundle_id_gate != "") {
        bundleIdArray.push(bundle_id_gate)
      }
    }

    //通信処理
    if (type == "Unique") {
      apiUrl = "https://aggregate-log-api.bcw-mt.com:5001/api/getUniqueUser/"
      //local
      //apiUrl = "http://localhost:5001/api/getUniqueUser/"
      if (await getUniqueUser(e, gte, lte) == false) {
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }

    } else {
      apiUrl = "https://aggregate-log-api.bcw-mt.com:5001/api/getLogData/"
      //local
      //apiUrl = "http://localhost:5001/api/getLogData/"
      if (await getLogData(e, gte, lte) == false) {
        
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }
  }

  const getUniqueUser = async(e: any, gte:any, lte: any) => {
    let ret = true;
    e.preventDefault();
    console.log("bundle_id_ios:" + bundle_id_ios);
    console.log("bundle_id_and:" + bundle_id_and);
    console.log("bundle_id_gate:" + bundle_id_gate);
    
    setIsLoading(true);
    await axios.post(apiUrl, {
        app_id: bundleIdArray,
        beacons: beaconIdArray,
        beacon_name: uniqueCountArray,
        spread_month: spreadMonth,
        spread_client: selectSpreadClient,
        gte: gte,
        lte :lte
      }, {
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }
      }
    )
    .then(async res => {
      console.log(res);
      if(res.status === 400) {
        alert("エラーが発生しました。")
        return ret = false
      } 
      const items = JSON.parse(JSON.stringify(res.data.aggregations))
      console.log(items)

      uniqueCountArray.forEach((el) => {
        items.by_beacon.buckets.forEach(element => {
          if (el.beacon_id == element.key) {
            el.log_count = element.doc_count;
            el.unique_count = element.unique_user_count.value
            return
          }
        });
      })      
  
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("駅別ユニーク集計");
      const worksheet = workbook.getWorksheet("駅別ユニーク集計");
      const columns: Partial<ExcelJS.Column>[] = [];
      columns.push({ header: "ビーコン名", key: "name" })
      columns.push({ header: "ビーコンID", key: "beacon_id" })
      columns.push({ header: "ビーコンログ数", key: "log_count" })
      columns.push({ header: "ユニークデバイスID数", key: "unique_count" })
      worksheet!.columns = columns;
      uniqueCountArray.forEach((el => {
        worksheet!.addRow(el)
      }))

      try {
        const uint8Array = await workbook.csv.writeBuffer();
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom,uint8Array], { type: 'application/octet-binary' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        setTimeout(()=> {
          a.href = url;
          a.download = "駅別ユニーク集計_" + getNowDate() +  ".csv";
          a.click();
          a.remove();
        },1000)

      } catch (error) {
        console.error(error);
        ret = false
      }

    })
    .catch(err => {
      alert("エラーが発生しました。" + err.message)
      ret = false
    })
    return ret
  }

  const getLogData = async(e: any, gte: any, lte: any ) => {
    let ret = true;
    e.preventDefault();
    console.log("bundle_id_ios:" + bundle_id_ios);
    console.log("bundle_id_and:" + bundle_id_and);
    console.log("bundle_id_gate:" + bundle_id_gate);
    setIsLoading(true);
    await axios.get(apiUrl,
    {
      headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
      },
      params: {
          app_id: bundleIdArray,
          beacons: beaconIdArray,
          gte: gte,
          lte :lte
      }
    })
    .then(async res => {
      console.log(res);
      if(res.status === 400) {
        alert("エラーが発生しました。")
        return ret = false
      } 
      const items = JSON.parse(JSON.stringify(res.data.aggregations))
      console.log(items)

      var countArray = [...Array(24)].map(() => 0);
      
      //月のループ
      items.by_day.buckets.forEach((day_el:any ) => {
        //時刻を取得
        var uTime = day_el.key;
        
        //1時間ごとに24回ループ
        for (var i = 0 ; i < 24 ; i++) {
          var hit = false;
          day_el.by_hour.buckets.forEach((hour_el:any) => {
            if (hour_el.key === uTime) {
              //console.log("uTime:" + uTime + " Count:" + hour_el.doc_count)
              countArray[i] = countArray[i] +  hour_el.doc_count
              hit = true
            } 
          });
          /*
          if (hit == false) {
            console.log("uTime:" + uTime + " Count:Zero")
          }
            */
          uTime = uTime + 3600000
        }
        
      });
    
      
      //連想配列へ
      const countedArray = {}
      countArray.forEach((el:any, i) => {
        countedArray[i] = el;
      })
      //console.log(countedArray)
      
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("時間別ビーコンログ数集計");
      const worksheet = workbook.getWorksheet("時間別ビーコンログ数集計");
      const columns: Partial<ExcelJS.Column>[] = [];

      columns.push({ header: "0時", key: "0" })
      columns.push({ header: "1時", key: "1" })
      columns.push({ header: "2時", key: "2" })
      columns.push({ header: "3時", key: "3" })
      columns.push({ header: "4時", key: "4" })
      columns.push({ header: "5時", key: "5" })
      columns.push({ header: "6時", key: "6" })
      columns.push({ header: "7時", key: "7" })
      columns.push({ header: "8時", key: "8" })
      columns.push({ header: "9時", key: "9" })
      columns.push({ header: "10時", key: "10" })
      columns.push({ header: "11時", key: "11" })
      columns.push({ header: "12時", key: "12" })
      columns.push({ header: "13時", key: "13" })
      columns.push({ header: "14時", key: "14" })
      columns.push({ header: "15時", key: "15" })
      columns.push({ header: "16時", key: "16" })
      columns.push({ header: "17時", key: "17" })
      columns.push({ header: "18時", key: "18" })
      columns.push({ header: "19時", key: "19" })
      columns.push({ header: "20時", key: "20" })
      columns.push({ header: "21時", key: "21" })
      columns.push({ header: "22時", key: "22" })
      columns.push({ header: "23時", key: "23" })
      worksheet!.columns = columns;
      worksheet!.addRow(countedArray)
      

      try {
        const uint8Array = await workbook.csv.writeBuffer();
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom,uint8Array], { type: 'application/octet-binary' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        setTimeout(()=> {
          a.href = url;
          a.download = "時間別ビーコンログ数集計_" + getNowDate() +  ".csv";
          a.click();
          a.remove();
        },1000)

      } catch (error) {
        console.error(error);
        ret = false
      }

    })
    .catch(err => {
      alert("エラーが発生しました。" + err.message)
      ret = false
    })
    return ret
  }


  const getUniqueDevice = async(e: any, gte: any, lte: any ) => {
    e.preventDefault();
    console.log("bundle_id_ios:" + bundle_id_ios);
    console.log("bundle_id_and:" + bundle_id_and);
    console.log("bundle_id_gate:" + bundle_id_gate);
    
    setIsLoading(true);
    await axios.get(apiUniqueDeviceUrl,
    {
      headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
      },
      params: {
          app_id: bundleIdArray,
          gte: gte,
          lte :lte
      }
    })
    .then(async res => {
      console.log(res);
      if(res.status === 400) {
        alert("エラーが発生しました。")
        return new Promise<void>((resolve, reject) => {
          reject()
        });
      } 
      const items = JSON.parse(JSON.stringify(res.data))
      console.log(items)

      uniqueDevice.device = items.hits.total.value
      uniqueDevice.unique_device = items.aggregations.unique_user_count.value
    
      return new Promise<void>((resolve, reject) => {
        resolve()
      }); 
    })
    .catch(err => {
      alert("エラーが発生しました。" + err.message)
      return new Promise<void>((resolve, reject) => {
        reject()
      });
    })
  }

  const getUniqueDeviceLocOn = async(e: any, gte: any, lte: any ) => {
    e.preventDefault();
    console.log("bundle_id_ios:" + bundle_id_ios);
    console.log("bundle_id_and:" + bundle_id_and);
    console.log("bundle_id_gate:" + bundle_id_gate);
    setIsLoading(true);
    await axios.get(apiUniqueDevLocOnUrl,
    {
      headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
      },
      params: {
          app_id: bundleIdArray,
          gte: gte,
          lte :lte
      }
    })
    .then(async res => {
      console.log(res);
      if(res.status === 400) {
        alert("エラーが発生しました。")
        return new Promise<void>((resolve, reject) => {
          reject()
        });
      } 
      const items = JSON.parse(JSON.stringify(res.data))
      console.log(items)

      uniqueDevice.locOn_device = items.hits.total.value
      uniqueDevice.locOn_unique_device = items.aggregations.unique_user_count.value
    
      return new Promise<void>((resolve, reject) => {
        resolve()
      }); 
    })
    .catch(err => {
      alert("エラーが発生しました。" + err.message)
      return new Promise<void>((resolve, reject) => {
        reject()
      });
    })
  }

  const getUniqueDeviceLocOff = async(e: any, gte: any, lte: any ) => {
    e.preventDefault();
    console.log("bundle_id_ios:" + bundle_id_ios);
    console.log("bundle_id_and:" + bundle_id_and);
    console.log("bundle_id_gate:" + bundle_id_gate);
    //setIsLoading(true);
    await axios.get(apiUniqueDevLocOffUrl,
    {
      headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
      },
      params: {
          app_id: bundleIdArray,
          gte: gte,
          lte :lte
      }
    })
    .then(async res => {
      console.log(res);
      if(res.status === 400) {
        alert("エラーが発生しました。")
        return new Promise<void>((resolve, reject) => {
          reject()
        });
      } 
      const items = JSON.parse(JSON.stringify(res.data))
      console.log(items)

      uniqueDevice.locOff_device = items.hits.total.value
      uniqueDevice.locOff_unique_device = items.aggregations.unique_user_count.value
    
      return new Promise<void>((resolve, reject) => {
        resolve()
      }); 
    })
    .catch(err => {
      alert("エラーが発生しました。" + err.message)
      return new Promise<void>((resolve, reject) => {
        reject()
      });
    })
  }
  
  const getUniqueDeviceBleOn = async(e: any, gte: any, lte: any ) => {
    e.preventDefault()
    //setIsLoading(true);
    await axios.get(apiUniqueDevBleOnUrl,
    {
      headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
      },
      params: {
          app_id: bundleIdArray,
          gte: gte,
          lte :lte
      }
    })
    .then(async res => {
      console.log(res);
      if(res.status === 400) {
        alert("エラーが発生しました。")
        return new Promise<void>((resolve, reject) => {
          reject()
        });
      } 
      const items = JSON.parse(JSON.stringify(res.data))
      console.log(items)

      uniqueDevice.bleOn_device = items.hits.total.value
      uniqueDevice.bleOn_unique_device = items.aggregations.unique_user_count.value
    
      return new Promise<void>((resolve, reject) => {
        resolve()
      }); 
    })
    .catch(err => {
      alert("エラーが発生しました。" + err.message)
      return new Promise<void>((resolve, reject) => {
        reject()
      });
    })
  }

  const getUniqueDeviceBleOff = async(e: any, gte: any, lte: any ) => {
    e.preventDefault()
    //setIsLoading(true);
    await axios.get(apiUniqueDevBleOffUrl,
    {
      headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
      },
      params: {
          app_id: bundleIdArray,
          gte: gte,
          lte :lte
      }
    })
    .then(async res => {
      console.log(res);
      if(res.status === 400) {
        alert("エラーが発生しました。")
        return new Promise<void>((resolve, reject) => {
          reject()
        });
      } 
      const items = JSON.parse(JSON.stringify(res.data))
      console.log(items)

      uniqueDevice.bleOff_device = items.hits.total.value
      uniqueDevice.bleOff_unique_device = items.aggregations.unique_user_count.value
    
      return new Promise<void>((resolve, reject) => {
        resolve()
      }); 
    })
    .catch(err => {
      alert("エラーが発生しました。" + err.message)
      return new Promise<void>((resolve, reject) => {
        reject()
      });
    })
  }

  const createUniqueDeviceCsv = async() => {
    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet("各種総数とユニーク数の集計");
    const worksheet = workbook.getWorksheet("各種総数とユニーク数の集計");
    const columns: Partial<ExcelJS.Column>[] = [];

    columns.push({ header: "総デバイスログ数", key: "device" })
    columns.push({ header: "総ユニークユーザー数", key: "unique_device" })
    columns.push({ header: "bluetooth trueのデバイスログ数", key: "bleOn_device" })
    columns.push({ header: "bluetooth trueのユニークユーザー数", key: "bleOn_unique_device" })
    columns.push({ header: "bluetooth falseのデバイスログ数", key: "bleOff_device" })
    columns.push({ header: "bluetooth falseのユニークユーザー数", key: "bleOff_unique_device" })
    columns.push({ header: "location trueのデバイスログ数", key: "locOn_device" })
    columns.push({ header: "location trueのユニークユーザー数", key: "locOn_unique_device" })
    columns.push({ header: "location falseのデバイスログ数", key: "locOff_device" })
    columns.push({ header: "location falseのユニークユーザー数", key: "locOff_unique_device" })
   
    worksheet!.columns = columns;
    worksheet!.addRow(uniqueDevice)
    

    try {
      const uint8Array = await workbook.csv.writeBuffer();
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom,uint8Array], { type: 'application/octet-binary' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      setTimeout(()=> {
        a.href = url;
        a.download = "各種総数とユニーク数の集計_" + getNowDate() +  ".csv";
        a.click();
        a.remove();
      },1000)

    } catch (error) {
      console.error(error);
    }
  }

  


  useEffect(() => {
   setBundle_id_ios(props.bundle_ids[0])
   setBundle_id_and(props.bundle_ids[1])
   setBundle_id_gate(props.bundle_ids[2])
   setSpreadClientOptions(['VAL', 'Wi2', 'OBK']); // 追加
  },[props.bundle_ids])
  

  const changeDetectedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    value.replace("T", " ");
    setDetcted_gt(value);
  }

  const changeDetectedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    value.replace("T", " ");
    setDetcted_lt(value);
  }

  const changeSpreadMonth = (value: string) => {
    if (value.length >= 1 && value.length < 7) {
      value = value + "-01";
    }
    value.replace("T", " ");
    setSpreadMonth(value);
  }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    let result = y  + m +  d;
    return result;
  }

  function IndeterminateCheckbox({
      indeterminate,
      className = '',
      ...rest
    }: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
      const ref = React.useRef<HTMLInputElement>(null!)
    
      React.useEffect(() => {
        if (typeof indeterminate === 'boolean') {
          ref.current.indeterminate = !rest.checked && indeterminate
        }
      }, [ref, indeterminate])
    
      return (
        <input
          type="checkbox"
          ref={ref}
          className={className + ' cursor-pointer'}
          {...rest}
        />
      )
    }

    return (
        
      <div>
        
        <Form className="font-weight-bold">
        
          <Form.Group as={Row} className="mx-3">
            <Col xs={12} md={4}>
              <Form.Label>BundleID(iOS)</Form.Label>
              <Form.Control type="text" name="uuid" disabled value={bundle_id_ios as string} className="w-27" onChange={(e) => setBundle_id_ios(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>BundleID(Android)</Form.Label>
              <Form.Control type="text" name="uuid" disabled value={bundle_id_and as string} className="w-27" onChange={(e) => setBundle_id_and(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>BundleID(GateWay)</Form.Label>
              <Form.Control type="text" name="uuid" disabled value={bundle_id_gate as string} className="w-27" onChange={(e) => setBundle_id_gate(e.target.value)} />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mx-3">

            <Col xs={12} md={4}>
              <Form.Label>Detected_gt（ビーコン発見時刻以降）</Form.Label>
              <Form.Control type="datetime-local" step="1" autoComplete="on" name="detected_gt" value={detected_gt as string} className="w-27" placeholder="ビーコン発見時の時刻（>=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetectedGt(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>Detected_lt（ビーコン発見時刻以前）</Form.Label>
              <Form.Control type="datetime-local" step="1" name="detected_lt" value={detected_lt as string} className="w-27" placeholder="ビーコン発見時の時刻（<=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetectedLt(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>SpreadSheetの対象年月</Form.Label>
              <Form.Control type="month" name="spreadMonth" value={spreadMonth as string} className="w-27"  onChange={(e) => changeSpreadMonth(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>SpreadSheetのクライアント名</Form.Label>
              <Form.Control as="select" id="spreadClient" value={selectSpreadClient as string} onChange={(e) => setSelectSpreadClient(e.target.value)}>
                <option value="">選択してください</option>
                {spreadClientOptions.map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </Form.Control>
              </Col>
          </Form.Group>
          <Form.Group as={Row} className="mx-3">
            <Col xs={12} md={4}>
              <Form.Label>テーブル除外フィルタ（部分一致で除外）</Form.Label>
              <Form.Control
                type="text"
                placeholder="除外する文字列をカンマ区切りで入力"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
          </Form.Group>
        
        <div className="text-center">
          <Button type="button" className="mt-3 mb-2 mr-2" onClick={(e) =>  getBeaconIds(e, "Logs")}>時間別ビーコンログ数集計を取得</Button>
          <Button type="button" className="mt-3 mb-2 mr-2" onClick={(e) => getBeaconIds(e, "Unique")}>ユニークユーザー数集計を取得</Button>
          <Button type="button" className="mt-3 mb-2 mr-2" onClick={(e) =>  getUniqueData(e)}>各種総数とユニーク数の集計を取得</Button>
        </div>
        </Form>
        
    
        <p className='mx-3'>項目の表示・非表示</p>
        <div id='colVisible' className="px-1 mx-3">
            {table.getAllLeafColumns().map(column => {
            return (
            <label className='mx-3'>

                <input
                    checked={column.getIsVisible()}
                    onChange={column.getToggleVisibilityHandler()}
                    type="checkbox"
                />{' '}
                {column.id}
            </label>
            )
            })}
        </div>
        <div className='dataScroll'>
            <table>
                <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th key={header.id}>
                        {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                        </th>
                    ))}
                    </tr>
                ))}
                </thead>
                <tbody>
                {table.getRowModel().rows.map((row) => (
                    <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                    ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
        {(() => {
        if (isLoading) {
          return (
            <div>
              <Loading/>
            </div>
          )
        }
        })()}
      </div>

      
    )
}

export default BeaconMasterResult